
const SkinConditionLabels: { [key: string]: string } = {
    "texture": "Txt591", // Texture
    "skin_dullness": "Txt573", // Dullness
    "face_wrinkles": "Txt577", // Finelines & Wrinkles
    "crows_feet": "Txt579", // Crows Feet
    "hydration": "Txt581", // Hydration
    "shine": "Txt585", // Oiliness
    "firmness": "Txt587", // Firmness
    "smoothness": "Txt589", // Smoothness
    "eye_wrinkles": "Txt780", // Eye wrinkle
    "skin_health": "Txt574", // Score (placeholder for Skin Health)
};

// Helper function to get translation with special handling for eye_wrinkles
export const getConcernTranslation = (getTranslation: (key: string) => string, concern: string): string => {
    const translationKey = SkinConditionLabels[concern];
    if (!translationKey) return concern;
    
    const translation = getTranslation(translationKey);
    
    // Special handling for eye_wrinkles to remove the
    if (concern === "eye_wrinkles") {
        return translation.replace("-", " ");
    }
    
    return translation;
};

export default SkinConditionLabels;
